import React from "react";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";

import heroBg from "../assets/heroBg.jpg";

const Hero = ({ onExploreClick }) => {
  // Using local asset for hero background

  return (
    <div className="position-relative vh-100 overflow-hidden d-flex align-items-center justify-content-center">
      {/* Background with Ken Burns Effect */}
      <motion.div
        initial={{ scale: 1.15 }}
        animate={{ scale: 1 }}
        transition={{ duration: 15, ease: "easeOut" }}
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", zIndex: 0 }}
      >
        <img
          src={heroBg}
          alt="Vintage Classic Car"
          style={{ width: "100%", height: "100%", objectFit: "cover", filter: "brightness(70%) contrast(1.1)" }}
        />
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "linear-gradient(to bottom, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.4) 100%)"
          }}
        />
      </motion.div>

      {/* Content Overlay */}
      <div className="container position-relative z-index-1 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          <h2
            className="text-uppercase text-accent mb-3"
            style={{
              letterSpacing: "5px",
              fontSize: "1rem",

              fontWeight: "bolder",
              fontFamily: "var(--font-body)"
            }}
          >
            Est. 1950
          </h2>
          <h1
            className="display-1 fw-bold mb-4"
            style={{
              fontFamily: "var(--font-heading)",
              color: "#fff",
              textShadow: "0 10px 30px rgba(0,0,0,0.5)"
            }}
          >
            The Art of <span className="text-accent">Motoring</span>
          </h1>
          <p
            className="lead mb-5 mx-auto"
            style={{
              maxWidth: "600px",
              color: "var(--primary-accent)",
              fontSize: "1.2rem",
              fontWeight: "300"
            }}
          >
            Experience the pinnacle of automotive history. Curated for the discerning collector.
          </p>

          <motion.button
            onClick={onExploreClick}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="btn btn-luxury d-inline-flex align-items-center gap-2"
          >
            Explore Collection <ChevronRight size={18} />
          </motion.button>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        className="position-absolute bottom-0 start-50 translate-middle-x mb-4"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        style={{ opacity: 0.7 }}
      >
        <div
          style={{
            width: "1px",
            height: "60px",
            background: "linear-gradient(to bottom, var(--text-main), transparent)"
          }}
        />
      </motion.div>
    </div>
  );
};

export default Hero;
